module.exports = __webpack_public_path__ + "img/16_30.7a5ec731.png";